import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Spin } from "antd";
import { useSelector } from "react-redux";

import { Roles } from "@/shared/utils/constants";
import SignatorySurveys from "../components/survey-list/SignatorySurveys";
import BaseTabs from "@/components_v2/Tabs/BaseTabs.js";
import SurveysTable from "@/features/survey/components/survey-list/SurveysTable";
import { selectCurrentUser } from "@/redux/authentication/selectors";

const SurveyList = () => {
  const { t } = useTranslation();

  const currentUser = useSelector(selectCurrentUser);

  const tabItems = useMemo(() => {
    if (!currentUser) return [];

    const columns = ["title", "type", "startDate", "deadline"];

    if (currentUser.role === Roles.ADMIN.value) {
      columns.push("invitesCount", "responsesCount");
    } else {
      columns.push("isDue", "status");
    }

    return [
      {
        label: t("survey.labels.myReports"),
        key: "organizationReports",
        children: (
          <SurveysTable
            columnNames={columns}
            filterNames={["search", "type", "status"]}
            defaultFilters={
              currentUser.role === Roles.ADMIN.value
                ? {}
                : { assignedToMe: true }
            }
          />
        ),
      },
      {
        label: t("survey.labels.signatoryReports"),
        key: "signatoryReports",
        children: <SignatorySurveys />,
      },
    ];
  }, [currentUser]);

  if (!currentUser) {
    return (
      <div className="d-flex justify-content-center align-items-center h-100">
        <Spin size="large" />
      </div>
    );
  }

  return <BaseTabs items={tabItems} />;
};

export default SurveyList;
